import { Component } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  templateUrl: './confirm-email-sent.component.html',
  styleUrls: ['./login-forms.scss']
})
export class ConfirmEmailSentComponent {

  constructor (private router: Router) { }
}



// WEBPACK FOOTER //
// ./src/app/login/forms/confirm-email-sent.component.ts